
import { Component, Prop, Vue } from 'vue-property-decorator'

import { Group } from '@/interfaces/Group'
import { MutationTypes } from '@/store/mutation-types'
import { GroupTag } from '@/interfaces/GroupTag'
import LazyImage from '@/components/LazyImage.vue'
import strings from '@/assets/strings.json'

@Component({
  components: {
    LazyImage
  }
})
export default class TypeSelector extends Vue {
  @Prop() private group!: Group;

  private generalStrings = strings.Generals

  onTagClick (tag: GroupTag) {
    this.$store.commit(
      MutationTypes.CHANGE_CURRENT_STEP,
      { currentStep: 1, group: this.group, tag }
    )
  }
}
